import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import { Settings } from 'luxon';
import '@/styles/index.scss';
import DetailFooter from '@/components/UI/DetailFooter.vue';
import BaseList from '@/components/BaseList.vue';
import Filters from '@/components/UI/Filters.vue';
import Chat from '@/components/Chat.vue';
import History from '@/components/History.vue';
import FilterItem from '@/components/UI/FilterItem.vue';
import DeleteModal from '@/components/DeleteModal.vue';
import DatePicker from '@/components/UI/DatePicker.vue';
import EntitySelect from '@/components/EntitySelect.vue';
import EntityPicker from '@/components/EntityPicker.vue';
import Calendar from '@/components/Calendar.vue';
import Error from './components/UI/Error.vue';
import Dropdown from './components/UI/Dropdown.vue';
Vue.config.productionTip = false;

Vue.component('DeleteModal', DeleteModal);
Vue.component('UIDatePicker', DatePicker);
Vue.component('entity-select', EntitySelect);
Vue.component('entity-picker', EntityPicker);
Vue.component('DetailFooter', DetailFooter);
Vue.component('Filters', Filters);
Vue.component('Chat', Chat);
Vue.component('History', History);
Vue.component('FilterItem', FilterItem);
Vue.component('error', Error);
Vue.component('dropdown', Dropdown);
Vue.component('BaseList', BaseList);
Vue.component('Calendar', Calendar)

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');

Settings.defaultLocale = 'ru';
